<ng-template #content><ng-content></ng-content></ng-template>
<ng-template #drawerFooter><ng-content select="sn-drawer-footer"></ng-content></ng-template>

<div
  *ngIf="resizable"
  mwlResizable
  [enableGhostResize]="true"
  [ngStyle]="resizeStyle"
  [validateResize]="resizeValidate"
  [resizeEdges]="{ left: true }"
  (resizing)="onResizeEnd($event)"
  class="fs__drawer-container fs__drawer-container-resize"
>
  <button
    mat-fab
    class="resize-drawer-btn"
    [matTooltip]="isFullscreen ? ('common.collapseResults' | t) : ('common.expandResults' | t)"
    (click)="$event.stopPropagation(); toggleResize()"
    (mousedown)="$event.stopPropagation()"
  >
    <sn-icon *ngIf="isFullscreen">keyboard_arrow_right</sn-icon>
    <sn-icon *ngIf="!isFullscreen">keyboard_arrow_left</sn-icon>
  </button>
  <button
    mat-fab
    class="draggable-drawer-btn"
    mwlResizeHandle
    [resizeEdges]="{ left: true }"
    [matTooltip]="'common.dragWindow' | t"
    (mouseup)="$event.stopPropagation()"
    (mousemove)="trackDraggableBtnClick()"
  >
    <sn-icon fontSet="fas" fontIcon="fa-grip-dots-vertical"></sn-icon>
  </button>
  <ng-container *ngTemplateOutlet="content"></ng-container>
  <ng-container *ngTemplateOutlet="drawerFooter"></ng-container>
</div>
<div *ngIf="!resizable" class="fs__drawer-container">
  <ng-container *ngTemplateOutlet="content"></ng-container>
  <ng-container *ngTemplateOutlet="drawerFooter"></ng-container>
</div>
